import {
  UPLOAD_DOCUMENT,
  UPLOAD_IMAGE,
  UPLOAD_VIDEO,
} from "../../../services/Endpoints";
import {
  DEFAULT_STATUS_CODE_SUCCESS,
  MESSAGE_UNKNOWN_ERROR_OCCURRED,
} from "../../../utils/AppConstants";
import { handleError, toastError } from "../../../utils/AppFunctions";

export const fetchUploadImageService = async (formData: FormData) => {
  try {
    const resUploadImage = await UPLOAD_IMAGE(formData);
    if (resUploadImage && resUploadImage.code === DEFAULT_STATUS_CODE_SUCCESS) {
      return resUploadImage.data.imagePath;
    } else {
      toastError(resUploadImage.data.error || MESSAGE_UNKNOWN_ERROR_OCCURRED);
    }
  } catch (error: any) {
    toastError(MESSAGE_UNKNOWN_ERROR_OCCURRED);
    handleError(error, "fetchUploadImageService");
  }
  return null;
};
export const uploadVideoService = async (formData: FormData) => {
  try {
    const resUploadVideo = await UPLOAD_VIDEO(formData);
    if (resUploadVideo && resUploadVideo.code === DEFAULT_STATUS_CODE_SUCCESS) {
      return resUploadVideo.data.documentPath;
    } else {
      toastError(resUploadVideo.data.error || MESSAGE_UNKNOWN_ERROR_OCCURRED);
    }
  } catch (error: any) {
    toastError(MESSAGE_UNKNOWN_ERROR_OCCURRED);
    handleError(error, "uploadVideoService");
  }
  return null;
};
export const uploadDocumentService = async (formData: FormData) => {
  try {
    const resUploadDocument = await UPLOAD_DOCUMENT(formData);
    if (
      resUploadDocument &&
      resUploadDocument.code === DEFAULT_STATUS_CODE_SUCCESS
    ) {
      return resUploadDocument.data.documentPath;
    } else {
      toastError(
        resUploadDocument.data.error || MESSAGE_UNKNOWN_ERROR_OCCURRED
      );
    }
  } catch (error: any) {
    toastError(MESSAGE_UNKNOWN_ERROR_OCCURRED);
    handleError(error, "uploadDocumentService");
  }
  return null;
};
